var getters = {
    userInfo: function (state) { var _a; return ((_a = state === null || state === void 0 ? void 0 : state.user) === null || _a === void 0 ? void 0 : _a.userInfo) || {}; },
    lang: function (state) { return state.app.lang; },
    app: function (state) { return state.app; },
    logo: function (state) {
        if (state.app.logo) {
            return state.app.logo;
        }
        return require('@/assets/img/logo.png');
    },
    name: function (state) {
        if (state.app.name) {
            return state.app.name;
        }
        return window.WKConfig.companyName;
    },
    nowMounth: function (state) { return state.app.nowMounth; },
    moduleData: function (state) { var _a; return ((_a = state.app) === null || _a === void 0 ? void 0 : _a.moduleData) || []; },
    collapse: function (state) { var _a; return (_a = state.app.sidebar) === null || _a === void 0 ? void 0 : _a.collapse; },
    systemAlertShow: function (state) { return state.app.systemAlertShow; },
    systemAlertProps: function (state) { return state.app.systemAlertProps; },
    moduleAuth: function (state) { return state.app.moduleAuth; },
    userList: function (state) { return state.user.userList; },
    userDeptObj: function (state) { return state.user.userDeptObj; },
    userDeptMap: function (state) { return state.user.userDeptMap; },
    searchUserDept: function (state) { return state.user.searchUserDept; },
    deptList: function (state) { return state.user.deptList; },
    // 权限
    allAuth: function (state) { return state.user.allAuth; },
    crm: function (state) { return state.user.crm; },
    bi: function (state) { return state.user.bi; },
    manage: function (state) { return state.user.manage; },
    oa: function (state) { return state.user.oa; },
    call: function (state) { return state.user.call; },
    isCall: function (state) { return state.crm.isCall; },
    // 路由
    addRouters: function (state) { return state.permission.addRouters; },
    crmRouters: function (state) { return state.permission.crmRouters; },
    taskExamineRouters: function (state) { return state.permission.taskExamineRouters; },
    workLogRouters: function (state) { return state.permission.workLogRouters; },
    addressBookRouters: function (state) { return state.permission.addressBookRouters; },
    biRouters: function (state) { return state.permission.biRouters; },
    manageRouters: function (state) { return state.permission.manageRouters; },
    oaRouters: function (state) { return state.permission.oaRouters; },
    fmRouters: function (state) { return state.permission.fmRouters; },
    // 客户管理信息
    messageNum: function (state) { return state.crm.messageNum; },
    // 配置信息
    CRMConfig: function (state) { return state.app.CRMConfig; },
    imageCache: function (state) { return state.app.imageCache; }
};
/**
 * 使用说明
 * import { mapGetters } from 'vuex'
 * computed: {
    ...mapGetters([
      'userInfo'
    ])
  }
 */
export default getters;
